exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.adminTitle {\n  font-weight: bold;\n  font-size: 120%;\n  border-bottom: 2px solid white;\n  padding-bottom: 0.1ex;\n  margin-top: 10px;\n  margin-bottom: 1ex;\n}\n\n* {\n  color: white ;\n}\n\ndiv {\n  margin-top: 1ex;\n}\n\ndiv.main {\n  padding: 7px;\n  background: brown;\n  border-radius: 12px;\n}\n\nli {\n  margin-bottom: 1ex;\n}\n\nspan.link:hover, span.link span:hover , a:hover  {\n  color: lightblue !important;\n}\n\nspan.link, a {\n  display: inline-block;\n  padding: 2px 5px;\n  color: white;\n  font-weight: bold;\n}\n\nspan.link.isOn {\n  background: gold;\n  color: maroon;\n}\n\ndiv.details {\n  padding-top: 1ex;\n  /* margin-top: 1ex; */\n  /* border-top: thick double white; */\n}\n\ndiv.inner {\n  background: white;\n  color: black;\n  padding: 12px;\n  border-radius: 8px;\n}\n\nbutton {\n  font-weight: bold;\n  color: green;\n}\n\nspan.msg {\n  font-weight:bold;\n  font-size: small;\n  font-style: italic;\n}\n\ndiv.info {\n  font-size: small;\n  font-style: italic;\n  color: white;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/admin-dashboard/admin-dashboard.component.css
// module id = ../../../../../src/app/admin-dashboard/admin-dashboard.component.css
// module chunks = main